"use strict";

var _toConsumableArray = require("/home/bitnami/upa-sign-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceBehavior = exports.preKeyupBehavior = exports.preKeydownBehavior = exports.postKeyupBehavior = exports.keyupBehavior = exports.keypressBehavior = exports.keydownBehavior = void 0;
var _utils = require("../../utils");
var arrowKeys = _interopRequireWildcard(require("./arrow"));
var controlKeys = _interopRequireWildcard(require("./control"));
var characterKeys = _interopRequireWildcard(require("./character"));
var functionalKeys = _interopRequireWildcard(require("./functional"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var replaceBehavior = [{
  matches: function matches(keyDef, element) {
    return keyDef.key === 'selectall' && (0, _utils.isElementType)(element, ['input', 'textarea']);
  },
  handle: function handle(keyDef, element, options, state) {
    var _state$carryValue;
    (0, _utils.setSelectionRange)(element, 0, ((_state$carryValue = state.carryValue) != null ? _state$carryValue : element.value).length);
  }
}];
exports.replaceBehavior = replaceBehavior;
var preKeydownBehavior = _toConsumableArray(functionalKeys.preKeydownBehavior);
exports.preKeydownBehavior = preKeydownBehavior;
var keydownBehavior = [].concat(_toConsumableArray(arrowKeys.keydownBehavior), _toConsumableArray(controlKeys.keydownBehavior), _toConsumableArray(functionalKeys.keydownBehavior));
exports.keydownBehavior = keydownBehavior;
var keypressBehavior = [].concat(_toConsumableArray(functionalKeys.keypressBehavior), _toConsumableArray(characterKeys.keypressBehavior));
exports.keypressBehavior = keypressBehavior;
var preKeyupBehavior = _toConsumableArray(functionalKeys.preKeyupBehavior);
exports.preKeyupBehavior = preKeyupBehavior;
var keyupBehavior = _toConsumableArray(functionalKeys.keyupBehavior);
exports.keyupBehavior = keyupBehavior;
var postKeyupBehavior = _toConsumableArray(functionalKeys.postKeyupBehavior);
exports.postKeyupBehavior = postKeyupBehavior;